<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        class="text-body"
        icon="HelpCircleIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <div class="text">
      <p>To better understand the data points shown on this page and for a description of the terminology used, please visit the <a href="/glossary">glossary</a>.</p>
    </div>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
}
</script>

<style>
  .text p {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: -5px;
    color: rgba(245, 245, 245, 0.815);
  }
</style>
